import { ProposalCommandType } from 'graphql/generated'
import {
  getCommandDescription,
  IProposalCommandInputProps
} from './ProposalCommand.types'
import { useEffect } from 'react'

function ChangeEnableWithdrawsCommand({
  onChange,
  onValidityChange,
  collective
}: IProposalCommandInputProps) {
  useEffect(() => {
    onChange({
      type: ProposalCommandType.CHANGE_ENABLE_WITHDRAWS,
      enableWithdraws: !collective.parameters.enableWithdraws
    })
    // eslint-disable-next-line
  }, [collective.parameters.enableWithdraws])

  const isValid = true
  useEffect(() => {
    onValidityChange(isValid)
    // eslint-disable-next-line
  }, [isValid])

  return (
    <div className="flex flex-col w-full">
      <div className="flex pt-4 justify-center items-center">
        <p className="text-gray-700 font-light text-sm">
          {getCommandDescription(
            ProposalCommandType.CHANGE_ENABLE_WITHDRAWS,
            collective
          )}
        </p>
      </div>
    </div>
  )
}

export default ChangeEnableWithdrawsCommand
